import API_URL from 'utils/ApiUrl'
import { Auth } from 'utils/Auth'

const fetchAuthHeader = async () => {
  const session = await Auth.currentSession()
  return `Bearer ${session.idToken.jwtToken ? session.idToken.jwtToken : ''}`
}

/**
 * Gets the number of unread notifications.
 * @returns {Promise<number>} The number of unread notifications
 */
export const fetchUnreadNotificationCount = async () => {
  const authorization = await fetchAuthHeader()
  const response = await fetch(`${API_URL}/notification/unread`, {
    cache: 'no-cache',
    method: 'GET',
    mode: 'cors',
    redirect: 'follow',
    referrer: 'no-referrer',
    headers: {
      authorization,
      'content-type': 'application/json',
    },
  })

  const { unread_notifications: unreadNotifications = 0 } =
    await response.json()

  return unreadNotifications
}

/**
 * Marks all notifications from a contact as read.
 * @param {string} contactId The id of the contact to mark all notifications as read for
 * @returns
 */
export const markAllAsReadForContact = async contactId => {
  const authorization = await fetchAuthHeader()
  const response = await fetch(
    `${API_URL}/notification/contact/${contactId}/allread`,
    {
      cache: 'no-cache',
      method: 'PUT',
      mode: 'cors',
      redirect: 'follow',
      referrer: 'no-referrer',
      headers: {
        authorization,
        'content-type': 'application/json',
      },
    },
  )

  return await response.json()
}
